<template>
    <v-container fluid v-if="this.$store.state.signedIn">
        <v-flex xs12 class="px-4 py-4">
            <v-card>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        Frequently asked questions (with answers)
                    </v-toolbar-title>
                    <v-spacer />
                    <v-flex>    
                        <feedback type="question"></feedback>
                    </v-flex>
                    <v-spacer />
                </v-toolbar>
                <v-card-text>
                    <v-flex class="px-2 py-2">
                        <v-card>
                            <v-toolbar color="accent">
                                <v-toolbar-title :style="$store.state.textFormatting.headers">
                                    What are Hijack and Impact scores?
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <h2 :style="$store.state.textFormatting.main"> Analytics within BGP Spotlight introduce Hijack and Impact scores which range from 0 - 100. </h2>
                                <h2 :style="$store.state.textFormatting.main">Hijack score attempts to deduce how likely the event is to be a genuine hijacking event, whereas Impact score gauges how damaging the event could be if it were a hijack.</h2>
                                <h2 :style="$store.state.textFormatting.main"> Whilst these are unique to BGP Spotlight and are not a prerequisite for BGP analysis, they are introduced here as they provide the ability to sort large volumes of BGP results to help identify the most suspicious activity within a large dataset. </h2>
                                <h2 :style="$store.state.textFormatting.main"> This tool also provides the ability to only show alerts for BGP activity above user defined thresholds. </h2>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <v-flex class="px-2 py-2">
                        <v-card>
                            <v-toolbar color="accent">
                                <v-toolbar-title :style="$store.state.textFormatting.headers">
                                    How do I set Hijack/Impact thresholds so that I see all data / no data is hidden?
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <h2 :style="$store.state.textFormatting.main"> When defining ASN alert thresholds,<v-btn :style="$store.state.textFormatting.main" @click="routeNewWindow('ASN Settings')" color="success" small> (Edit ASNs page) </v-btn> setting the Hijack and Impact thresholds to 0, will show ALL change activity for entered ASNs.  </h2>
                                <h2 :style="$store.state.textFormatting.main">Note if you have entered specific ranges i.e. 'Restricted Prefixes', these do not use alerting thresholds - you will be provided with all alerts that match your entered ranges.</h2>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <v-flex class="px-2 py-2">
                        <v-card>
                            <v-toolbar color="accent">
                                <v-toolbar-title :style="$store.state.textFormatting.headers">
                                    What alert thresholds should I set for my monitored ASNs?
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <h2 :style="$store.state.textFormatting.main"> Each use case and each ASN is different. Where possible we suggest setting thresholds initially low (or 0), then review the volume of data and adjust the thresholds accordingly to your needs. </h2>
                                <h2 :style="$store.state.textFormatting.main"> A fuller description of how Hijack and Impact scores are calculated are available on the <v-btn :style="$store.state.textFormatting.main" @click="routeNewWindow('Analytics')" color="success" small> Analytics </v-btn> page </h2>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                </v-card-text>
            </v-card>
            <br />
        </v-flex>
    </v-container>
</template>

<script>

import info from '../../shared/operational/infopopout.vue';
import feedback from '../../shared/operational/feedback-window.vue';

export default {
  name: 'faq',
  components: {
      feedback
  },
  data () {
    return {
        qna: [
            
        ]
    };
  },
  mounted () {
  },
  beforeMount() {  
  },
  methods: {
    routeNewWindow: async function (input) {
        let routeData = this.$router.resolve({name: input});
        window.open(routeData.href, '_blank');
    }
  }
};
</script>
